import { BASE } from "@/config";

const SuperAdminIndex = () => import("@/views/superadmin/Index.vue");
const MainSuperAdminView = () =>
  import("@/views/superadmin/MainSuperAdminView.vue");
const VisitsView = () => import("@/views/superadmin/VisitsView.vue");
const ReauthView = () => import("@/views/superadmin/ReauthView.vue");
const OperatorsView = () =>
  import("@/views/superadmin/operators/OperatorsView");
const AgreementsView = () =>
  import("@/views/superadmin/agreements/AgreementsView");
const SettingsView = () => import("@/views/superadmin/settings/SettingsView");
const ApiKeysView = () => import("@/views/superadmin/external/ApiKeysView");

import StatRoutes from "@/router/superadmin/stat";
import CardRoutes from "@/router/superadmin/card";
import UsersRoutes from "@/router/superadmin/users";
import TariffsRoutes from "@/router/superadmin/tariffs";
import SupportRoutes from "@/router/superadmin/support";
import NotificationsRoutes from "@/router/superadmin/notifications";
import ReportsView from "@/views/superadmin/reports/ReportsView";
import SyncView from "@/views/superadmin/sync/SyncView";

export {
  StatRoutes,
  UsersRoutes,
  CardRoutes,
  TariffsRoutes,
  SupportRoutes,
  NotificationsRoutes,
};
export default {
  path: "/superadmin",
  component: SuperAdminIndex,
  meta: { role: BASE.ROLES.SUPERADMIN, auth: "auth" },
  children: [
    {
      path: "",
      name: "MainSuperAdminView",
      component: MainSuperAdminView,
      meta: { label: "Главная" },
    },
    {
      path: "operators",
      name: "OperatorsSuperAdmin",
      component: OperatorsView,
      meta: { label: "Операторы" },
    },
    StatRoutes,
    CardRoutes,
    UsersRoutes,
    TariffsRoutes,
    NotificationsRoutes,
    {
      path: "visits",
      name: "VisitsSuperAdmin",
      component: VisitsView,
      meta: { label: "Проходы" },
    },
    {
      path: "agreements",
      name: "AgreementsSuperAdmin",
      component: AgreementsView,
      meta: { label: "Оферта" },
    },
    {
      path: "re-auth",
      name: "ReauthorizationSuperAdmin",
      component: ReauthView,
      meta: { label: "Авторизация" },
    },
    SupportRoutes,
    {
      path: "settings",
      name: "SettingsSuperAdmin",
      component: SettingsView,
      meta: { label: "Глобальные настройки" },
    },
    {
      path: "apiKeys",
      name: "ApiKeysSuperAdmin",
      component: ApiKeysView,
      meta: { label: "Внешние API-ключи" },
    },
    {
      path: "reports",
      name: "SuperadminReports",
      component: ReportsView,
      meta: { label: "Отчеты" },
    },
    {
      path: "sync",
      name: "SuperadminSync",
      component: SyncView,
      meta: { label: "Синхронизация" },
    },
  ],
};
